import { animated } from '@react-spring/web';
import moment from 'moment/moment';
import { type AxisTickProps } from '@nivo/axes';
import { dayAbbreviations } from '../constants';

import type { JSX } from 'react';

const BarChartAxisBottomTicks = ({
  animatedProps,
  lineX,
  lineY,
  textBaseline,
  textAnchor,
  value,
  textX,
  textY,
}: AxisTickProps<any>): JSX.Element => {
  return (
    <animated.g transform={animatedProps.transform} opacity={animatedProps.opacity}>
      <line x1={0} x2={lineX} y1={0} y2={lineY} />
      <animated.text
        className="bottom-axis-label text-xs-regular"
        dominantBaseline={textBaseline as never}
        textAnchor={textAnchor as never}
        transform={animatedProps.textTransform}
      >
        {moment(value).date()}
      </animated.text>
      <animated.text
        className="bottom-axis-label text-xs-regular"
        dominantBaseline={textBaseline as never}
        textAnchor={textAnchor as never}
        transform={`translate(${textX},${textY + 15})`}
      >
        {dayAbbreviations[moment(value).day()]}
      </animated.text>
    </animated.g>
  );
};

export default BarChartAxisBottomTicks;
